import React, { useEffect } from 'react'
import './App.css'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import AuthLayout from './common/layout/AuthLayout'
import { protectedRoutes, publicRoutes } from './common/router/allRoutes'
import Redirect from './common/components/router/Redirect'
import MainLayout from './common/layout/MainLayout'
import { worker } from './common/mocks/browser'
import Protector from './common/components/router/Protector'
import CommonModal from './common/ui/CommonModal'
import CommonSnackbar from './common/ui/CommonSnackbar'
function App() {
	/*useEffect(() => {
		worker.start()
	}, [])*/

	return (
		<React.Fragment>
			<Router>
				<Routes>
					<Route path="/" element={<Redirect />} />
					<Route element={<AuthLayout />}>
						{publicRoutes.map(({ path, component: Component }, index) => (
							<Route key={index} path={path} element={<Component />} />
						))}
					</Route>
					<Route element={<Protector />}>
						<Route element={<MainLayout />}>
							{protectedRoutes.map(({ path, component: Component }, index) => (
								<Route key={index} path={path} element={<Component />} />
							))}
						</Route>
					</Route>
				</Routes>
			</Router>
			<CommonModal />
			<CommonSnackbar />
		</React.Fragment>
	)
}

export default App
